import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Hidden, Typography } from '@material-ui/core';
import i18next from 'i18next';
import AppLayout from '../../commons/AppLayout/AppLayout';
import RTVDialog from '../../commons/dialogs/RTVDialog';
import RtvButton from '../../commons/Buttons/RtvButton';
import LogoRTVPlus from '../../images/Logos/Logo_RTCplus.svg';

import Feed from './Feed';
import CarouselSection from './CarouselSection';

// Messages
import {
  WELCOME_SHOWROOM,
  WELCOME_REGULAR,
  PUBLISHED_REGULAR,
  PUBLISHED_SHOWROOM,
  PUBLISHED_PREMIUM
} from '../../commons/messages/messageTypes';
import PublishedRegular from '../../commons/messages/PublishedRegular';
import PublishedShowroom from '../../commons/messages/PublishedShowroom';
import PublishedPremium from '../../commons/messages/PublishedPremium';
import WelcomeRegular from '../../commons/messages/WelcomeRegular';
import WelcomeShowroom from '../../commons/messages/WelcomeShowroom';
import { getBanners } from '../../redux/actions/publicity';
import { BANNERS_RETRIEVED } from '../../redux/actions/types';
import RTVMarketingFlash from '../../commons/RTVMarketingFlash';
import SustainabilityMeter from '../../commons/SustainabilityMeter/SustainabilityMeter';

const styles = theme => ({
  rowHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(2),
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  scrollSection: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  text1: {
    fontWeight: 700
  },
  text2: {
    fontStyle: 'italic'
  },
  text3: {
    fontWeight: 200
  },
  text4: {
    fontWeight: 500
  },
  asideContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '60px 0 0 0'
  },
  rtvPlusWelcomeModalLogo: {
    backgroundColor: '#000',
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: '8px',
    marginBottom: theme.spacing(2)
  },
  rtvPlusWelcomeModalLogoImg: {
    height: '2.5em',
    width: 'auto',
    display: 'block'
  },
  rtvPlusWelcomeModalTitle: {
    fontWeight: 600,
    fontSize: '1.25rem',
    color: '#E76262',
    marginBottom: theme.spacing(1)
  },
  rtvPlusWelcomeModalMessage: {
    color: '#757575',
    fontSize: '0.95rem',
    marginBottom: theme.spacing(2)
  }
});

const assignMessage = messageType => {
  switch (messageType) {
    case WELCOME_SHOWROOM:
      return WelcomeShowroom;
    case WELCOME_REGULAR:
      return WelcomeRegular;
    case PUBLISHED_REGULAR:
      return PublishedRegular;
    case PUBLISHED_SHOWROOM:
      return PublishedShowroom;
    case PUBLISHED_PREMIUM:
      return PublishedPremium;
    default:
      return PublishedRegular;
  }
};

class Home extends Component {
  constructor(props) {
    super();

    let notFound = props.location.state && props.location.state.notFound;
    if (!notFound && props.notFound) {
      notFound = true;
    }

    const locationState = props.location.state;
    // Solo mostramos la pantalla de "producto publicado" cuando el state trae
    // datos de publicación. Navegaciones como el modal de bienvenida de
    // RTCplus+ (que sólo setean showRtvPlusWelcomeModal) no deben dispararla.
    const hasPublishState =
      locationState &&
      (locationState.message !== undefined ||
        locationState.messageText !== undefined ||
        locationState.title !== undefined ||
        locationState.producttitle !== undefined ||
        locationState.productPath !== undefined);

    this.state = {
      banners: [],
      notFound,
      showRtvPlusWelcomeModal:
        (locationState && locationState.showRtvPlusWelcomeModal) || false,
      appLayoutOptions: hasPublishState
        ? {
            title: locationState.title,
            subtitle: locationState.subtitle,
            productTitle: locationState.producttitle,
            productPath: locationState.productPath,
            message: locationState.messageText
              ? locationState.messageText
              : assignMessage(locationState.message)
          }
        : {}
    };
  }

  componentDidMount() {
    this.props.getBanners();
  }

  onCloseRtvPlusWelcomeModal = () => {
    this.setState({ showRtvPlusWelcomeModal: false });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.bannersStatus !== this.props.bannersStatus) {
      if (this.props.bannersStatus === BANNERS_RETRIEVED) {
        this.setState({ banners: this.props.banners });
      }
    }
  }

  render() {
    const { appLayoutOptions } = this.state;

    return (
      <AppLayout
        title={appLayoutOptions.title}
        subtitle={appLayoutOptions.subtitle}
        message={appLayoutOptions.message}
        publishedProduct={{
          title: appLayoutOptions.productTitle,
          path: appLayoutOptions.productPath
        }}
        footer={!this.state.hasMoreCarousels}
        banners={this.state.banners}
        notFound={this.state.notFound}
        showMarquee
      >
        <RTVMarketingFlash
          location="LIVE_GENERAL_LOCATIONS"
          containerProps={{ style: { margin: '16px 42px' } }}
          liveEnabled
        />
        <div
          style={{
            display: 'flex'
          }}
        >
          <div className={this.props.classes.scrollSection}>
            <CarouselSection user={this.props.user?.id} />
          </div>
          <div className={this.props.classes.asideContainer}>
            <Hidden smDown>
              <SustainabilityMeter />
              <Feed />
            </Hidden>
          </div>
        </div>
        <RTVDialog
          open={this.state.showRtvPlusWelcomeModal}
          onClose={this.onCloseRtvPlusWelcomeModal}
          dialogProps={{ PaperProps: { style: { minWidth: 370 } } }}
          noTitle
          noActionSection
          content={
            <>
              <div className={this.props.classes.rtvPlusWelcomeModalLogo}>
                <img
                  src={LogoRTVPlus}
                  alt="RTVplus+"
                  className={this.props.classes.rtvPlusWelcomeModalLogoImg}
                />
              </div>
              <Typography
                className={this.props.classes.rtvPlusWelcomeModalTitle}
              >
                {i18next.t('welcomeModal.title', { ns: 'rtvPlus' })}
              </Typography>
              <Typography
                className={this.props.classes.rtvPlusWelcomeModalMessage}
              >
                {i18next.t('welcomeModal.message', { ns: 'rtvPlus' })}
              </Typography>
              <RtvButton
                variant="rtvRed"
                onClick={this.onCloseRtvPlusWelcomeModal}
                style={{ minWidth: 120, borderRadius: 24 }}
              >
                {i18next.t('welcomeModal.button', { ns: 'rtvPlus' })}
              </RtvButton>
            </>
          }
        />
      </AppLayout>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  banners: state.publicity.banners,
  bannersStatus: state.publicity.status
});

const mapDispatchToProps = dispatch => ({
  getBanners: () => dispatch(getBanners())
});

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))
);
